const MOVE_LIST_REQUEST = 'MOVE_LIST_REQUEST';
const MOVE_LIST_SUCCESS = 'MOVE_LIST_SUCCESS';
const MOVE_LIST_FAILURE = 'MOVE_LIST_FAILURE';

const MOVE_REQUEST = 'MOVE_REQUEST';
const MOVE_SUCCESS = 'MOVE_SUCCESS';
const MOVE_FAILURE = 'MOVE_FAILURE';

const MOVE_ADD_REQUEST = 'MOVE_ADD_REQUEST';
const MOVE_ADD_SUCCESS = 'MOVE_ADD_SUCCESS';
const MOVE_ADD_FAILURE = 'MOVE_ADD_FAILURE';

const MOVE_EDIT_REQUEST = 'MOVE_EDIT_REQUEST';
const MOVE_EDIT_SUCCESS = 'MOVE_EDIT_SUCCESS';
const MOVE_EDIT_FAILURE = 'MOVE_EDIT_FAILURE';

const MOVE_DELETE_REQUEST = 'MOVE_DELETE_REQUEST';
const MOVE_DELETE_SUCCESS = 'MOVE_DELETE_SUCCESS';
const MOVE_DELETE_FAILURE = 'MOVE_DELETE_FAILURE';

const MOVE_MOVES_REQUEST = 'MOVE_MOVES_REQUEST';
const MOVE_MOVES_SUCCESS = 'MOVE_MOVES_SUCCESS';
const MOVE_MOVES_FAILURE = 'MOVE_MOVES_FAILURE';

const MOVE_POKEMONS_REQUEST = 'MOVE_POKEMONS_REQUEST';
const MOVE_POKEMONS_SUCCESS = 'MOVE_POKEMONS_SUCCESS';
const MOVE_POKEMONS_FAILURE = 'MOVE_POKEMONS_FAILURE';

const MOVE_CHANGE_QUERY = 'MOVE_CHANGE_QUERY';


const types = {
    MOVE_LIST_REQUEST,
    MOVE_LIST_SUCCESS,
    MOVE_LIST_FAILURE,
    
    MOVE_REQUEST,
    MOVE_SUCCESS,
    MOVE_FAILURE,

    MOVE_ADD_REQUEST,
    MOVE_ADD_SUCCESS,
    MOVE_ADD_FAILURE,

    MOVE_EDIT_REQUEST,
    MOVE_EDIT_SUCCESS,
    MOVE_EDIT_FAILURE,

    MOVE_DELETE_REQUEST,
    MOVE_DELETE_SUCCESS,
    MOVE_DELETE_FAILURE,

    MOVE_MOVES_REQUEST,
    MOVE_MOVES_SUCCESS,
    MOVE_MOVES_FAILURE,

    MOVE_POKEMONS_REQUEST,
    MOVE_POKEMONS_SUCCESS,
    MOVE_POKEMONS_FAILURE,
    
    MOVE_CHANGE_QUERY,
}

export default types;